// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var InnerTextSemantic$SmartcutsMacros = require("./InnerTextSemantic.bs.js");

function t_encode(v) {
  return InnerTextSemantic$SmartcutsMacros.VariableInnerTextConfig.t_encode(v);
}

function t_decode(v) {
  return InnerTextSemantic$SmartcutsMacros.VariableInnerTextConfig.t_decode(v);
}

function fromAuthoringConfig(param) {
  var chosen = param.chosen;
  if (typeof chosen === "number" || chosen.TAG !== /* VariableInnerText */5) {
    return ;
  } else {
    return chosen._0;
  }
}

function getPlaybackFormLabelFromParam(param) {
  return param.playbackFormLabel;
}

function removePrivateInfo(v) {
  return {
          playbackFormLabel: v.playbackFormLabel,
          defaultValue: ""
        };
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.fromAuthoringConfig = fromAuthoringConfig;
exports.getPlaybackFormLabelFromParam = getPlaybackFormLabelFromParam;
exports.removePrivateInfo = removePrivateInfo;
/* InnerTextSemantic-SmartcutsMacros Not a pure module */
